import { App } from '../modules/app'
import { PageConfig } from '../modules/shared/config/page-config';
import { LoginHandler } from '../modules/login/handlers/login-handler';

let loginPageInfo = new PageConfig(new LoginHandler(), "login");
window.app = new App(loginPageInfo)